var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DISCORD_copie",
    "data-name": "DISCORD copie",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.894,
    height: 13.617,
    viewBox: "0 0 17.894 13.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DISCORD_copie-2",
    "data-name": "DISCORD copie",
    d: "M1643.257,46.734A14.961,14.961,0,0,1,1645.9,56.9a.057.057,0,0,1-.023.041A14.777,14.777,0,0,1,1641.4,59.2a.058.058,0,0,1-.063-.021,11.945,11.945,0,0,1-.913-1.484.057.057,0,0,1,.031-.079,9.208,9.208,0,0,0,1.4-.663.058.058,0,0,0,0-.1c-.095-.07-.188-.144-.278-.217a.055.055,0,0,0-.059-.007,10.6,10.6,0,0,1-8.993,0,.054.054,0,0,0-.057.008c-.089.074-.183.146-.277.216a.057.057,0,0,0,.006.1,9.737,9.737,0,0,0,1.4.663.057.057,0,0,1,.031.079,10.623,10.623,0,0,1-.914,1.486.061.061,0,0,1-.063.02,14.833,14.833,0,0,1-4.468-2.255.063.063,0,0,1-.023-.042,15.064,15.064,0,0,1,2.643-10.168.053.053,0,0,1,.024-.02,14.7,14.7,0,0,1,3.642-1.128.06.06,0,0,1,.059.028,9.487,9.487,0,0,1,.46.93,13.639,13.639,0,0,1,4.091,0,10.191,10.191,0,0,1,.454-.93.056.056,0,0,1,.059-.028,14.777,14.777,0,0,1,3.642,1.128.041.041,0,0,1,.024.021Zm-7.584,6.338a1.619,1.619,0,1,0-3.216,0,1.619,1.619,0,1,0,3.216,0Zm5.946,0a1.618,1.618,0,1,0-3.216,0,1.618,1.618,0,1,0,3.216,0Z",
    transform: "translate(-1628.086 -45.584)",
    fill: "#00649e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.37cf4145040c632c5b347bb7f09bf36f.svg";
export { ForwardRef as ReactComponent };